"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _clsx = _interopRequireDefault(require("clsx"));
var _lodash = require("lodash");
var _reactRouterDom = require("react-router-dom");
var _core = require("@material-ui/core");
var _reactI18next = require("react-i18next");
var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));
var _bookmarkIcon = _interopRequireDefault(require("../bookmark-icon"));
var _image = _interopRequireDefault(require("../../helper/image"));
var _resolveImage = _interopRequireDefault(require("../../utils/resolveImage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _core.makeStyles)(theme => {
  var _theme$palette$backgr, _theme$palette$foregr;
  return {
    root: {
      background: theme.palette.primary.main,
      display: "block"
    },
    link: {
      display: "block"
    },
    imageDiv: {
      paddingTop: "79.834%",
      position: "relative"
    },
    notLoaded: {
      display: "none"
    },
    content: {
      bottom: 0,
      left: 0,
      position: "absolute",
      right: 0,
      top: 0
    },
    bookmark: {
      alignItems: "center",
      backgroundColor: (_theme$palette$backgr = theme.palette.background) === null || _theme$palette$backgr === void 0 ? void 0 : _theme$palette$backgr.bookmark,
      borderRadius: "50%",
      color: (_theme$palette$foregr = theme.palette.foreground) === null || _theme$palette$foregr === void 0 ? void 0 : _theme$palette$foregr.bookmark,
      cursor: "pointer",
      display: "flex",
      height: theme.spacing(3.5),
      justifyContent: "center",
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      width: theme.spacing(3.5)
    },
    text: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      maxHeight: 75,
      minHeight: 75,
      padding: theme.spacing(1)
    },
    title: {
      color: theme.palette.common.white,
      display: "block",
      maxHeight: "calc(1.2em * 3)",
      overflow: "hidden",
      textAlign: "center",
      textOverflow: "ellipsis"
    },
    date: {
      background: "linear-gradient(to right, #747a85, rgba(116, 122, 133, 0.7))",
      color: theme.palette.common.white,
      left: theme.spacing(1),
      padding: theme.spacing(1),
      position: "absolute",
      top: theme.spacing(1)
    },
    dateItem: {
      "& span": {
        display: "block",
        fontWeight: theme.typography.fontWeightBold
      }
    },
    time: {
      background: "linear-gradient(to right, #747a85, rgba(116, 122, 133, 0.7))",
      bottom: theme.spacing(1),
      color: theme.palette.common.white,
      left: theme.spacing(-1),
      padding: theme.spacing(1),
      position: "absolute",
      "&::before": {
        borderStyle: "solid",
        borderWidth: theme.spacing(0, 1, 1, 0),
        borderColor: "transparent #2d343e transparent transparent",
        bottom: theme.spacing(-1),
        content: "''",
        height: 0,
        left: 0,
        position: "absolute",
        transform: "rotate(360deg)",
        width: 0
      }
    },
    timeItem: {
      display: "table",
      lineHeight: 1.2,
      textTransform: "none"
    },
    timeLabel: {
      display: "inline-block",
      marginRight: theme.spacing(0.5)
    }
  };
});
const TeaserSliderItem = props => {
  const {
    dateFrom,
    dateTo,
    id,
    type,
    lang,
    link,
    media,
    mediaFormat,
    title,
    skeleton,
    showBookmark
  } = props;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  let {
    timeFrom,
    timeTo
  } = props;
  if (timeFrom && timeFrom.length > 5) {
    timeFrom = (0, _moment.default)(timeFrom).format("HH:mm");
  }
  if (timeTo && timeTo.length > 5) {
    timeTo = (0, _moment.default)(timeTo).format("HH:mm");
  }
  const formattedDateFrom = formatDate(dateFrom, lang);
  const formattedDateTo = formatDate(dateTo, lang);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.root, "teaser-slider-item")
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: css.link,
    to: link
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.imageDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.content
  }, /*#__PURE__*/_react.default.createElement(TeaserSliderItemImage, {
    media: (0, _lodash.first)(media),
    mediaFormat: mediaFormat,
    skeleton: skeleton
  }), (formattedDateFrom || formattedDateTo) && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)(css.date, "teaser-slider-item__date")
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.dateItem,
    variant: "overline",
    component: "span"
  }, formattedDateFrom !== formattedDateTo ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, formattedDateFrom), /*#__PURE__*/_react.default.createElement("span", null, formattedDateTo)) : /*#__PURE__*/_react.default.createElement("span", null, formattedDateFrom))), (timeFrom || timeTo) && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)(css.time, "teaser-slider-item__time")
  }, timeFrom && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.timeItem,
    variant: "overline",
    component: "span"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: css.timeLabel
  }, timeTo ? t("site.ui.labels.from") : t("site.ui.labels.from2")), timeFrom, " ", t("site.ui.labels.time")), timeTo && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.timeItem,
    variant: "overline",
    component: "span"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: css.timeLabel
  }, t("site.ui.labels.to")), timeTo, " ", t("site.ui.labels.time"))))), /*#__PURE__*/_react.default.createElement("p", {
    className: css.text
  }, title ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.title,
    variant: "h3",
    component: "span",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    animation: "wave",
    height: 18,
    width: 200
  }))), showBookmark && /*#__PURE__*/_react.default.createElement(_bookmarkIcon.default, {
    id: id,
    type: type,
    title: title,
    link: link
  }));
};
const TeaserSliderItemImage = props => {
  var _subFormat, _subFormat2, _subFormat3, _subFormat4, _subFormat5;
  const {
    media,
    mediaFormat = "teaser-slider"
  } = props;
  const {
    REACT_APP_PATH
  } = process.env;
  let subFormat = null;
  if (media !== null && media !== void 0 && media.subFormats) {
    subFormat = (0, _lodash.first)((0, _resolveImage.default)(media === null || media === void 0 ? void 0 : media.subFormats, mediaFormat));
  }
  if (!subFormat) {
    console.warn("teaser-slider-item: fallback main format (format teaser-slider not found)");
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_image.default, {
    filename: ((_subFormat = subFormat) === null || _subFormat === void 0 ? void 0 : _subFormat.filename) && (((_subFormat2 = subFormat) === null || _subFormat2 === void 0 ? void 0 : _subFormat2.filename.charAt(0)) === "/" ? REACT_APP_PATH : "") + ((_subFormat3 = subFormat) === null || _subFormat3 === void 0 ? void 0 : _subFormat3.filename),
    height: (_subFormat4 = subFormat) === null || _subFormat4 === void 0 ? void 0 : _subFormat4.height,
    width: (_subFormat5 = subFormat) === null || _subFormat5 === void 0 ? void 0 : _subFormat5.width,
    alt: media === null || media === void 0 ? void 0 : media.alt
  }));
};
const formatDate = (dateString, lang) => {
  const dateObj = dateString ? new Date(dateString) : null;
  return dateObj ? dateObj.toLocaleDateString(lang, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    weekday: "short"
  }) : null;
};
TeaserSliderItem.defaultProps = {
  showBookmark: false
};
var _default = exports.default = TeaserSliderItem;